export const scrollToContact = () => {
  const block = document.querySelector('.BlockContact')
  const nav = document.querySelector('.nav')
  const blockY = block.offsetTop + nav.offsetHeight
  window.scrollTo({
    top: blockY,
    behavior: 'smooth',
  })
}

export const makeYellow = (filename) => {
  const arr = filename.split('.')
  const newFilename = `${arr[0]}_yellow.${arr[1]}`
  return newFilename
}

// from https://www.wpgraphql.com/docs/menus/
export const flatListToHierarchical = (
  data = [],
  { idKey = 'key', parentKey = 'parentId', childrenKey = 'children' } = {}
) => {
  const tree = []
  const childrenOf = {}
  data.forEach((item) => {
    const newItem = { ...item }
    const { [idKey]: id, [parentKey]: parentId = 0 } = newItem
    childrenOf[id] = childrenOf[id] || []
    newItem[childrenKey] = childrenOf[id]
    parentId
      ? (childrenOf[parentId] = childrenOf[parentId] || []).push(newItem)
      : tree.push(newItem)
  })
  return tree
}

export const capitalize = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
}

export const isObjectEmpty = (obj) => {
  for (var key in obj) {
    if (obj[key] !== null && obj[key] != '') return false
  }
  return true
}
